<!-- eslint-disable no-restricted-syntax -->
<template>
  <!-- eslint-disable vue/no-v-html -->
  <div v-if="isLoaded">
    <CardStatistic
      :items="ticketStatus"
      class="mb-2"
    />
    <!-- <div class="d-flex height-600">
      <div
        v-if="$checkRole(roleAnnouncementPost, profile.role)"
        class="w-100">
        <Announcement
          :group-service-options="groupService"
          @create-announcement="createAnnouncement($event)"
        />
      </div>
      <div
        v-if="filteredAnnouncements && filteredAnnouncements.length > 0"
        class="w-100 pl-2 overflow-y-scroll">
        <p>POST</p>
        <div id="post">
          <div
          >
            <b-card
              v-for="(announcement, index) in filteredAnnouncements"
              :key="`post-${index}`"
              class="mb-2"
            >
              <div
                v-if="checkRoleAndOwnPost(announcement, profile)"
                class="d-flex justify-content-end"
              >
                <b-button
                  class="mr-2"
                  :variant="checkSelectedAnnouncementIndex(index) ? 'primary' : 'warning'"
                  @click="handleFormAnnouncementEdit(index)"
                >
                  {{ checkSelectedAnnouncementIndex(index) ? 'ยกเลิก' : 'แก้ไข' }}
                </b-button>
                <b-button
                  variant="danger"
                  @click="deleteAnnouncement(announcement.id)">
                  ลบ
                </b-button>
              </div>
              <div v-if="!checkSelectedAnnouncementIndex(index)">
                <b-row class="mb-1">
                  <b-col>
                    <div>
                      <h3 class="d-block font-weight-medium text-xl">
                        {{ announcement.title }}
                      </h3>
                      <div
                        class="ql-editor"
                        v-html="announcement.description"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex">
                    <div class="mr-1">
                      <b-avatar
                        size="38"
                        variant="light-primary"
                        :text="symbolProfile(announcement.createdBy.username)"
                      />
                    </div>
                    <div>
                      <span class="d-block font-weight-semibold">{{ announcement.createdBy.username }}</span>
                      <span>{{ announcement.createdAt | formatDateEn }}</span>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <AnnouncementEdit
                v-else
                :group-service-options="groupService"
                :announcement-title="announcement.title"
                :announcement-description="announcement.description"
                :announcement-role="announcement.role"
                :announcement-group-service="announcement.groupService"
                @update:announcement-title="announcement.title = $event"
                @update:announcement-description="announcement.description = $event"
                @update:announcement-role="announcement.role = $event"
                @update:announcement-group-service="announcement.groupService = $event"
                @update-announcement="updateAnnouncement(announcement.id, $event)"
              />
            </b-card>
          </div>
        </div>
      </div>
    </div> -->
    <b-card class="mt-4">
      <div class="table-container-wrapper">
        <b-table
          ref="dashTable"
          :items="items"
          :fields="fields"
          striped
          hover
          responsive
          @sort-changed="sortChanged"
          @row-clicked="rowClick($event)">
          >
          <template #cell(code)="{item}">
            <div
              v-if="item.code"
              class="d-flex">
              <div>
                {{ item.code }}
              </div>
              <div
                v-if="item.isTransfer"
                class="ml-2">
                <img
                  width="25"
                  height="25"
                  alt="Transfer"
                  src="@/assets/images/icons/transfer.png"
                />
              </div>
              <div
                v-if="item.isNewEmail"
                class="ml-2">
                <img
                  width="25"
                  height="25"
                  alt="Email Notification"
                  src="@/assets/images/icons/notification-email.png"
                />
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(incidentType)="data">
            <div v-if="data.item.tickeType && data.item.tickeType.name">
              {{ data.item.tickeType.name }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(createdAt)="data">
            <div v-if="data.item.createdAt">
              {{ data.item.createdAt | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(updatedAt)="data">
            <div v-if="data.item.updatedAt">
              {{ data.item.updatedAt | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(createdBy)="data">
            <div v-if="data.item && data.item.createdBy ">
              {{ data.item.createdBy.username }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(progressBy)="data">
            <div v-if="data.item && data.item.progressBy.firstName && data.item.progressBy.lastName ">
              {{ data.item.progressBy.firstName }} {{ data.item.progressBy.lastName }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(dueDate)="data">
            <div v-if="data.item.dueDate">
              {{ data.item.dueDate | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(resolveDate)="data">
            <div v-if="data.item.resolveDate">
              {{ data.item.resolveDate | formatDateTimeEnShort }}
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template #cell(ticketStatus)="data">
            <b-badge :variant="$ticketStatus(data.value)">
              {{ data.value | formatTicketStatus }}
            </b-badge>
            <svg xmlns="http://www.w3.org/2000/svg" v-if="data.item.remark2" v-b-popover.hover.right="data.item.remark2" title="Note" class="icon icon-tabler icon-tabler-notes" width="28" height="28" viewBox="0 0 24 24" stroke-width="1.5" stroke="#7367f0" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
            <path d="M9 7l6 0" />
            <path d="M9 11l6 0" />
            <path d="M9 15l4 0" />
            </svg>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-col
      cols="12"
      sm="12"
      class="d-flex align-items-center justify-content-center justify-content-sm-end">
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.totalDocs"
        :per-page="pagination.limit"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
        @change="showCurrentPage($event)"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18" />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18" />
        </template>
      </b-pagination>
    </b-col>
    <!-- <ClickToCallModal
      v-model="isModalTest"
      phone-number="+66613034686" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCard, BCol } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import Announcement from '@/components/Dashboard/Announcement.vue'
// import AnnouncementEdit from '@/components/Dashboard/AnnouncementEdit.vue'
import CardStatistic from '@/components/Dashboard/CardStatistic.vue'
import AnnouncementProvider from '@/resources/AnnouncementProvider'
import TicketProvider from '@/resources/TicketProvider'
import GroupProvider from '@/resources/GroupProvider'
import PermissionAnnouncementPost from '@/common/permission/dashboard/announcement-post'
// import ClickToCallModal from '@/components/Modal/ClickToCallModal.vue'

const AnnouncementService = new AnnouncementProvider()
const TicketService = new TicketProvider()
const GroupService = new GroupProvider()

export default {
  components: {
    // ClickToCallModal,
    BCard,
    // BAvatar,
    // BRow,
    BCol,
    // Announcement,
    CardStatistic
    // AnnouncementEdit
  },
  data () {
    return {
      isModalTest: true,
      announcements: null,
      isLoaded: false,
      content: '<p><a href="https://www.youtube.com/" rel="noopener noreferrer" target="_blank">Youtube</a></p><p><br></p><p>Gasdfsafsafas</p>',
      fields: [
        { key: 'ticketStatus', label: 'Status', sortable: false, thStyle: { width: '160px' } },
        { key: 'code', label: 'Ticket No.', sortable: true },
        { key: 'ticketCodeRefer', label: 'Refer No.', sortable: false },
        { key: 'incidentType', label: 'Ticket Type', sortable: false },
        { key: 'subject', label: 'subject', sortable: false },
        { key: 'customerName', label: 'CustomerName', sortable: false },
        { key: 'userGroup.name', label: 'Group', sortable: false },
        { key: 'userTeam.name', label: 'Team', sortable: false },
        { key: 'createdAt', label: 'CreateAt', sortable: true },
        { key: 'progressBy', label: 'ProgressBy', sortable: false },
        { key: 'dueDate', label: 'DueDate', sortable: true }
      ],
      items: [],
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 10
      },
      ticketStatus: {
        open: 0,
        closed: 0,
        void: 0,
        overDue: 0
      },
      filter: {
        sort: 'dueDate',
        sortOrder: 'DESC'
      },
      roleAnnouncementPost: PermissionAnnouncementPost,
      groupService: [],
      selectedAnnouncementIndex: null,
      currentAnnouncementBeforeEdit: null,
      observeEvent: []
    }
  },
  computed: {
    filteredAnnouncements () {
      if (this.announcements && Array.isArray(this.announcements)) {
        return this.announcements.filter((announcement) => this.$checkRoleAndGroup(
          announcement.role,
          this.profile.role,
          announcement.groupService,
          this.profile.userGroupId
        ) || announcement.createdBy.id === this.profile.id)
      }
      return []
    },
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      profile: 'User/user'
    })
  },
  async created () {
    // this.getAnnouncement()
    // window.addEventListener('message', this.receiveMessage)
    // this.observeMax()
    this.isLoaded = false
    try {
      this.$store.dispatch('activity/increaseLoading')
      await Promise.all([
        this.getGroupService(),
        this.getTicket(),
        this.getTicketStatus()
      ])
    } finally {
      this.isLoaded = true
      this.$store.dispatch('activity/decreaseLoading')
    }
  },
  methods: {
    receiveMessage (event) {
      // this.observeEvent.push(event?.data)
      console.log('receiveMessage===>', event?.data)
    },
    observeMax () {
      // Find the parent window (MAX) to register for events
      console.log('Running Post Message... RegisterForClientEvents')
      const opener = window.opener || window.parent

      // Set up your subscriptions
      const subscriptionTypes = ['all']

      // Start listening for response messages
      const doSomething = (events) => {
        // eslint-disable-next-line no-unused-vars
        // let event = null
        // let eventIndex = null
        // // eslint-disable-next-line no-restricted-syntax
        // for (eventIndex in events) {
        //   // eslint-disable-next-line no-prototype-builtins
        //   if (events.hasOwnProperty(eventIndex)) {
        //     event = events[eventIndex]
        //   }
        // }
        console.log(events)
        // Do something with the event data
      }

      const listenForPostMessage = (event) => {
        if (
          event.data
    && event.data.events
    && event.data.issuer === 'MAX'
        ) {
          console.log('MAX ===>', event.data)
          this.observeEvent.push(event.data)
          doSomething(event.data.events)
        }
      }

      // Add the listener for MAX client events.
      window.addEventListener('message', listenForPostMessage)

      // Send the registration message to MAX
      opener.postMessage(
        {
          issuer: 'Tubtim',
          messageType: 'RegisterForClientEvents',
          subscriptionTypes
        },
        '*'
      )
      console.log('End Post Message...')
    },
    async getAnnouncement () {
      try {
        const data = await AnnouncementService.findAll()
        this.announcements = data.data
      } catch (error) {
        console.error(error)
      }
    },
    async getGroupService () {
      try {
        // Lean Redis-backed list (id/code/name) — avoids unbounded findAll(1, 9999)
        const { data } = await GroupService.findAllGroupCode({ skipLoading: true })
        this.groupService = Array.isArray(data) ? data : []
      } catch (error) {
        console.error(error)
      }
    },
    async getTicket () {
      try {
        const data = await TicketService.paginate(this.pagination.page, this.pagination.limit,
          {
            ticketStatus: ['open', 'over Due'],
            userId: this.profile?.id,
            type: 'dashboard',
            ...this.filter
          },
          { skipLoading: true })
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (error) {
        console.error(error)
      }
    },
    async getTicketStatus () {
      try {
        const { data } = await TicketService.findAllStatus(this.profile.id, { skipLoading: true })
        this.ticketStatus = data
      } catch (error) {
        console.error(error)
      }
    },
    async createAnnouncement (payload) {
      try {
        await AnnouncementService.create(payload)
        await this.getAnnouncement()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Post Announcement Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: 'Announcement has been posted'
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async updateAnnouncement (id, payload) {
      try {
        await AnnouncementService.update(id, payload)
        await this.getAnnouncement()
      } catch (error) {
        console.error(error)
      } finally {
        this.selectedAnnouncementIndex = null
      }
    },
    async deleteAnnouncement (id) {
      try {
        await AnnouncementService.remove(id)
        await this.getAnnouncement()
      } catch (error) {
        console.error(error)
      } finally {
        this.selectedAnnouncementIndex = null
      }
    },
    rowClick (val) {
      this.$router.push(`/ticket/detail/${val.id ? val.id : null}`)
    },
    symbolProfile (value) {
      return value.slice(0, 2)
    },
    showCurrentPage (page) {
      console.log(this.$refs.dashTable)
      this.$refs.dashTable.refresh()
      this.setPagination(page)
      this.getTicket()
    },
    setPagination (page, totalDocs) {
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs === 0 ? 0 : totalDocs || this.pagination.totalDocs
    },
    handleFormAnnouncementEdit (index) {
      if (index === this.selectedAnnouncementIndex) {
        this.selectedAnnouncementIndex = null
        this.announcements[index] = this.currentAnnouncementBeforeEdit
      } else {
        this.currentAnnouncementBeforeEdit = { ...this.announcements[index] }
        this.selectedAnnouncementIndex = index
      }
    },
    checkSelectedAnnouncementIndex (index) {
      if (index === this.selectedAnnouncementIndex) {
        return true
      }
      return false
    },
    checkRoleAndOwnPost (announcement, profile) {
      const allowedRoles = ['super admin', 'supervisor']
      return (
        allowedRoles.includes(profile?.role)
        || (announcement?.createdBy?.id === profile?.id)
      )
    },
    sortChanged (event) {
      this.filter.sort = event.sortBy || 'dueDate'
      this.filter.sortOrder = event.sortDesc ? 'DESC' : 'ASC'
      if (event.sortBy === 'createdAt') {
        this.filter.sort = 'id'
      }
      this.getTicket()
    }
  }
}
</script>

<style scoped>
.card-body {
  padding-top: 32px;
  padding-bottom: 32px;
}
.ql-editor {
  padding: 0;
}
.zoom-80 {
  zoom: 80%;
}

/* FIX: ป้องกัน table-responsive push layout */
.table-container-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden; /* บังคับให้ไม่ขยายออกไป */
  position: relative;
}

/* ล็อคความกว้างของ table-responsive */
.table-container-wrapper >>> .table-responsive {
  max-width: 100% !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
  
  /* ป้องกัน push layout */
  display: block;
  margin: 0;
  
  table {
    margin-bottom: 0;
  }
}
</style>
